import Cookies from "universal-cookie";

export interface HubspotFormField {
  name: string;
  value: string | undefined;
}

/**
 * Ad blockers and corporate networks routinely block api.hsforms.com, so a
 * rejection here is expected traffic rather than a fault.
 */
export default function submitHubspotForm(
  formId: string,
  fields: HubspotFormField[],
): Promise<void> {
  const portalId = "20608300";
  const postUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;
  const cookies = new Cookies();
  const isBrowser = typeof window !== "undefined";
  const hutk = isBrowser ? cookies.get("hubspotutk") : null;
  const pageUri = isBrowser ? window.location.href : null;
  const pageName = isBrowser ? document.title : null;
  return fetch(postUrl, {
    method: "post",
    body: JSON.stringify({
      submittedAt: Date.now(),
      fields,
      context: {
        hutk: hutk,
        pageUri: pageUri,
        pageName: pageName,
      },
    }),
    headers: new Headers({
      "Content-Type": "application/json",
      Accept: "application/json, application/xml, text/plain, text/html, *.*",
    }),
  })
    .then(() => undefined)
    .catch(() => undefined);
}
